import { styled } from "@mui/material/styles";

import { LabeledSectionSkeleton } from "../components/LabeledSectionSkeleton";
import { ProductAvailabilitySkeleton } from "./ProductAvailabilitySkeleton";
import { ProductContentSections } from "./ProductContentSections";
import {
    ProductFullWrapper,
    ProductFullMainLayout,
    ProductMainLayoutMode,
    ProductFullGalleryWrapper,
    ProductFullSideContentWrapper,
    ProductFullMainContentWrapper,
    ProductFullSideContentStyled,
} from "./ProductFullLayoutComponents";
import { ProductGallerySkeleton } from "./ProductGallerySkeleton";
import { ProductHeaderSkeleton } from "./ProductHeaderSkeleton";
import { ProductMetaSkeleton } from "./ProductMetaSkeleton";

const ProductFullSkeletonWrapper = styled("div")(({ theme }) => ({
    marginBottom: theme.spacing(2),
}));

type ProductFullV2SkeletonProps = {
    constrainWidth?: boolean;
    withStickyAppBar: boolean;
    layoutMode?: ProductMainLayoutMode;
};

export function ProductFullSkeleton(props: ProductFullV2SkeletonProps) {
    const { withStickyAppBar, layoutMode = "default" } = props;

    return (
        <ProductFullSkeletonWrapper>
            <ProductHeaderSkeleton withStickyAppBar={withStickyAppBar} showHeader={true} />
            <ProductFullWrapper>
                <ProductFullMainLayout layoutMode={layoutMode}>
                    <ProductFullGalleryWrapper>
                        <ProductGallerySkeleton />
                    </ProductFullGalleryWrapper>
                    <ProductFullSideContentWrapper>
                        <ProductFullSideContentStyled>
                            <ProductAvailabilitySkeleton />
                        </ProductFullSideContentStyled>
                    </ProductFullSideContentWrapper>
                    <ProductFullMainContentWrapper>
                        <ProductMetaSkeleton />
                        <ProductContentSections>
                            <LabeledSectionSkeleton />
                        </ProductContentSections>
                    </ProductFullMainContentWrapper>
                </ProductFullMainLayout>
            </ProductFullWrapper>
        </ProductFullSkeletonWrapper>
    );
}
